<div [ngStyle]="{'height': chartHeight + 'px'}" >
  <canvas baseChart
    [data]="lineChartData"
    [options]="lineChartOptions"
    [type]="chartType">
  </canvas>
</div>

